// extracted by mini-css-extract-plugin
export default {"gralLazyLoading":"lazyloading_gralLazyLoading__Ny-os","imgLazy":"lazyloading_imgLazy__vfXqw"};